export default __webpack_public_path__ + "static/media/tl5.1ab20be6.svg";